import CitizenConfig from '../config';
// import { addNotification } from './ErrorActions';
import axios from 'axios';

export const REQUEST_NEW_ALBUMS = 'REQUEST_NEW_ALBUMS';
export const RECEIVE_NEW_ALBUMS = 'RECEIVE_NEW_ALBUMS';
export const INVALIDATE_NEW_ALBUMS = 'INVALIDATE_NEW_ALBUMS';

// todo consolidate const #albumsPerPage
const ALBUMS_PER_PAGE = 90;
const API_ALBUMS_URL_BACKUP = `${CitizenConfig.API_URL}/wp/v1/albums?per_page=${ALBUMS_PER_PAGE}`;
// const API_ALBUMS_URL = `/api/albums`;
const API_ALBUMS_URL = `${CitizenConfig.API_URL}/wp/v1/albums?per_page=${ALBUMS_PER_PAGE}`;

function requestPosts() {
  return {
    type: REQUEST_NEW_ALBUMS
  };
}

function receiveNewAlbums(json) {
  return {
    type: RECEIVE_NEW_ALBUMS,
    posts: json.data,
    receivedAt: Date.now()
  };
}

function fetchNewAlbums() {
  return (dispatch, history) => {
    dispatch(requestPosts());

    return axios.get(API_ALBUMS_URL)
      .then(res => {
        dispatch(receiveNewAlbums(res))
      })
      .catch(err => {
        // try one more time with the fallback before giving up.
        // #cacheFallbacks
        console.warn(`Warning cache api is down: Using fallback url: ${API_ALBUMS_URL_BACKUP}`);

        axios.get(API_ALBUMS_URL_BACKUP)
          .then(res => {
            dispatch(receiveNewAlbums(res))
          })
      });
  };
}

function shouldFetchNewAlbums(state) {
  const posts = state;

  if (!posts.items) {
    return true;
  } else if (posts.isFetching) {
    return false;
  } else {
    return posts.didInvalidate;
  }
}

export function fetchNewAlbumsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchNewAlbums(getState())) {
      return dispatch(fetchNewAlbums());
    }
  };
}


// WEBPACK FOOTER //
// ./src/actions/HomeActions.js